<template>
  <div class="listing-page">
    <header class="header">
      <div class="row">
        <div class="columns small-12 medium-8">
          <div class="text-widget subheader">Simple apps for your classroom</div>
          <h1>{{ title }}</h1>
          <p>
            {{ description }}
          </p>
        </div>
      </div>
    </header>

    <resources-list :pagination="true" :params="params" :col-count="3" />
  </div>
</template>

<script>
import ResourcesList from '~/components/resource/ResourcesList.vue';

export default {
  name: 'WidgetsIndex',
  components: {
    ResourcesList,
  },
  data() {
    return {
      title: 'Widgets',
      description: 'Digital activities and interactive games built for the big screen. ',
      params: {
        country: this.$i18n.locale,
        orderBy: 'name',
        order: 'asc',
        payload: 'basic',
        perPage: 30,
        types: ['widget'],
      },
    };
  },
  jsonld() {
    return this.$jsonSchemaPage(this.title, this.$route.path);
  },
  head() {
    return {
      title: this.title,
      meta: [
        { hid: 'title', name: 'title', content: this.title },
        { hid: 'description', name: 'description', content: this.description },
      ],
      link: this.$hrefLangsPage(this.$route),
    };
  },
  mounted() {
    this.$mzAnalyticsApi({ event: 'pageView' });
  },
};
</script>
